import React, { useState, useEffect } from "react";
import './catering-checkbox-group.scss'
import { useDispatch } from 'react-redux';
import {
    handleUpdateCateringAndMealCartCustomOption
} from "redux/actions";

const CateringCheckBoxGroup = ({
    groupData,
    custom_options_arr,
    productIndex,
    setShowProductButton
}) => {
    const dispatch = useDispatch()
    const { values, title, is_required, title: label, is_add_option_price, id: groupId, max_selection } = groupData

    const [selectedOption, setSelectedOption] = useState([]);
    const [selectedOptionData, setSelectedOptionData] = useState([]);

    useEffect(() => {

        const defaultSelectedOption = custom_options_arr.filter(option => option.option_id === groupId).map(el => el.value)
        const defaultSelectedOptionData = custom_options_arr.filter(option => option.option_id === groupId)

        setSelectedOptionData(defaultSelectedOptionData)
        setSelectedOption(defaultSelectedOption)

    }, [custom_options_arr]) // eslint-disable-line



    const selectedOptionIds = selectedOptionData.map(op => op.id)

    const handleChangeOption = (optionValue, option) => {
        const { id, option_id, price, value } = option

        let updatedIftCheckedList = selectedOption;

        if (updatedIftCheckedList.includes(optionValue)) {
            updatedIftCheckedList = updatedIftCheckedList.filter(
                (iftType) => iftType !== optionValue
            );
            setShowProductButton()
        } else {

            if (max_selection !== "0" && (updatedIftCheckedList.length <= (+max_selection - 1))) {
                updatedIftCheckedList.push(optionValue);
                setShowProductButton()
            }
            if (!+max_selection) {
                updatedIftCheckedList.push(optionValue);
                setShowProductButton()
            }

        }

        let updatedOptionList = selectedOptionData;
        if (selectedOptionIds.includes(id)) {
            updatedOptionList = updatedOptionList.filter(
                (iftType) => iftType.id !== id
            );
        } else {

            if (max_selection !== "0" && (updatedOptionList.length <= (+max_selection - 1))) {
                updatedOptionList.push({ id, is_add_option_price, label, option_id, price, value });
            }
            if (!+max_selection) {
                updatedOptionList.push({ id, is_add_option_price, label, option_id, price, value });
            }
        }

        setSelectedOption([...updatedIftCheckedList])
        setSelectedOptionData([...updatedOptionList])
        dispatch(handleUpdateCateringAndMealCartCustomOption({ [groupId]: [...updatedOptionList] }, productIndex, true))
    }

    return (
        <div className="catering-checkbox-group">
            <p><strong>{title}</strong>{is_required === "1" && <span>*</span>}</p>
            <div className="catering-checkbox-group-item-list">
                {values && values.length && values.map((option => {
                    return <div className="catering-item-with-checkbox" key={option.id}>
                        <input
                            type="checkbox"
                            id={option.id + productIndex}
                            onChange={() => handleChangeOption(option.value, option)}
                            checked={selectedOption.includes(option.value)}
                        />
                        <label htmlFor={option.id + productIndex}>
                            <span>{option.value}</span>
                        </label>
                    </div>
                }))}
            </div>
        </div>
    );
};

export default CateringCheckBoxGroup;
